<template>
  <div id="dialog-wheelTimeChooser">
    <span class="cls" @click="cancel()"></span>
    <div class="dialog">
      <h2>시간 선택</h2>
      <div class="content">
        <!-- 시 피커 -->
        <VueScrollPicker
          :options="hourOptions"
          v-model="selectedHour"
          :empty-text="'시 없음'"
          :wheel-sensitivity="1.2"
          @update:modelValue="onUpdate('hour', $event)"
        />

        <!-- 분 피커 -->
        <VueScrollPicker
          :options="minuteOptions"
          v-model="selectedMinute"
          :empty-text="'분 없음'"
          :wheel-sensitivity="1.2"
          @update:modelValue="onUpdate('minute', $event)"
        />
      </div>
      <button @click="submitTime">확인</button>
    </div>
  </div>
</template>

<script>
import { ref } from "vue"
import { VueScrollPicker } from 'vue-scroll-picker'
import 'vue-scroll-picker/style.css'

export default {
  props: {
    defaultTime: String // 예: '14:30'
  },
  components: { VueScrollPicker },
  emits: ['submit'],
  setup(props, { emit }) {
    console.log(props.defaultTime);
    
    const current = new Date();
    const timeParts = props.defaultTime?.split(':') || [];
    const defaultHour = Number(timeParts[0]) ?? current.getHours();
    const defaultMinute = Number(timeParts[1]) ?? current.getMinutes();

    const hourOptions = Array.from({ length: 24 }, (_, i) => ({ name: `${i}시`, value: i }));
    const minuteOptions = Array.from({ length: 60 }, (_, i) => ({ name: `${i}분`, value: i }));

    const selectedHour = ref(defaultHour);
    const selectedMinute = ref(defaultMinute);

    function submitTime() {
      emit('submit', {
        hour: selectedHour.value,
        minute: selectedMinute.value
      });
    }

    function cancel() {
      emit('submit', {
        hour: null,
        minute: null
      });
    }

    function onUpdate(type, value) {
      console.log(`${type} 선택됨:`, value);
    }

    return {
      hourOptions,
      minuteOptions,
      selectedHour,
      selectedMinute,
      submitTime,
      cancel,
      onUpdate
    }
  }
}
</script>


<style scoped>
#dialog-wheelTimeChooser {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.cls {
  position: absolute;
  width:100%;
  height:100%;
  cursor: pointer;
  z-index: -1;
}

#dialog-wheelTimeChooser > .dialog {
  left: var(--font-size-lg);
  top: var(--font-size-7xl);
  width: 400px;
  height: auto;
  padding: 24px;
  box-sizing: border-box;
  background: var(--color-background);
  backdrop-filter: blur(var(--effect-blur));
  color: var(--color-text-primary);
  border-radius: 24px;
  max-height: 70vh;
  overflow: scroll;
  scrollbar-width: none;
  border: 1px solid var(--color-text-primary);
}

.dialog h2 {
  font-size: var(--font-size-lg);
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
}

.dialog > .content {
  display: flex;
  flex-direction: row;
  gap: 16px;
}

.dialog > button {
  width: 100%;
  height: 36px;
  background-color: var(--color-brand);
  color: var(--color-text-secondary);
  border: none;
  border-radius: 8px;
  cursor: pointer;
}
</style>

<style>
.vue-scroll-picker-item {
  color: var(--color-text-primary);
  opacity: 0.8;
  font-size: 20px;
}
.vue-scroll-picker-item[aria-selected=true] {
  color: var(--color-brand);
  opacity: 1;
}

@media (prefers-color-scheme: dark) {
  .vue-scroll-picker-layer-bottom {
    background: linear-gradient(0deg, #000 10%, rgba(0, 0, 0, .7)) !important;
  }
  .vue-scroll-picker-layer-top {
    background: linear-gradient(180deg, #000 10%, rgba(0, 0, 0, .7)) !important;
  }
}

@media (prefers-color-scheme: light) {
  .vue-scroll-picker-layer-bottom {
    background: linear-gradient(0deg, #fff 10%, rgba(255, 255, 255, .7)) !important;
  }
  .vue-scroll-picker-layer-top {
    background: linear-gradient(180deg, #fff 10%, rgba(255, 255, 255, .7)) !important;
  }
}
</style>
